import { createReducer, createActions } from 'reduxsauce'

// Initial State
export const initialState = {
    headData: {
        title: null,
        metas: {}
    }
}

// Types and Action Creators
const { Types, Creators } = createActions(
    {
        clean: null,
        setHeadData: ['headData'],
        addHeadData: ['headData'],
    },
    {
        prefix: 'PAGE_'
    }
)
export const PageTypes = Types

// Reducers and Handlers
export const handlers = {
    [Types.CLEAN]: () => initialState,
    [Types.SET_HEAD_DATA]: (state = initialState, { headData }) => ({
        ...state,
        headData: { ...initialState.headData, ...headData }
    }),
    [Types.ADD_HEAD_DATA]: (state = initialState, { headData }) => ({
        ...state,
        headData: {
            ...state.headData,
            ...headData,
            metas: { ...state.headData.metas, ...headData.metas }
        }
    }),
}

export const reducer = createReducer(initialState, handlers)
export default Creators



// WEBPACK FOOTER //
// src/store/redux/page.js